import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
const SuiteFeatureTableBadge = ({
  use = 'new',
  translationKey = 'recommended'
}) => {
  return /*#__PURE__*/_jsx(Badge, {
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricingPagesLib.badges.${translationKey}`
    })
  });
};
export default SuiteFeatureTableBadge;